import React from 'react';
import PropTypes from 'prop-types';
import momentTz from 'moment-timezone';
import { FormattedDate, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import classNames from 'classnames';

export const getDisplayDateTime = ({ timeZoneId = '', schedule = [] }) => {
  function momentifyDate (dateTime) {
    const { date, time } = dateTime;
    // uses global moment function
    const momentDateTime = momentTz.tz(`${date.y}-${date.m}-${date.d} ${time.h}:${time.m}`, 'YYYY-MM-DD HH:mm', timeZoneId);
    return momentDateTime;
  }

  function returnBookingDateRange (bk) {
    const bookingSchedule = bk || [];
    return bookingSchedule.map((session) => {
      const { start, end } = session;
      let endsNextDay;
      const startDateTime = start ? momentifyDate(start, timeZoneId) : null;
      const endDateTime = end ? momentifyDate(end, timeZoneId) : null;
      if (start && end) {
        endsNextDay = (startDateTime.date() !== endDateTime.date());
      }
      return {
        startDateTime,
        endDateTime,
        endsNextDay,
        start,
        end
      };
    });
  }
  return returnBookingDateRange(schedule);
};

class Schedule extends React.Component {
  constructor (props) {
    super(props);
    this.checkForDateTime = this.checkForDateTime.bind(this);
  }

  checkForDateTime (time) {
    const { start, end, startDateTime, endDateTime } = time;
    if ((start && start.time.h) && (end && (null !== end.time.h))) {
      const startTime = startDateTime ? startDateTime.format('h:mm a') : null;
      const endTime = endDateTime ? endDateTime.format('h:mm a') : null;
      const nextDay = ' ' + this.props.intl.formatMessage({ id: 'elements_forms.schedule.next_day', defaultMessage: '(next day)' });
      const formattedStartTime = this.props.intl.formatTime(moment(startTime, 'LT').format());
      const formattedEndTime = this.props.intl.formatTime(moment(endTime, 'LT').format());
      return <span>{formattedStartTime} - {formattedEndTime} {time.endsNextDay ? nextDay : null}</span>;
      // return <span>{formattedStartTime} - {formattedEndTime} {startDateTime.format('z')} {time.endsNextDay ? nextDay : null}</span>;
    }
    return <FormattedMessage id="web_2.schedule.time_not_specified" defaultMessage="Time not specified" />;
  }

  render () {
    const displayDateTime = getDisplayDateTime(this.props);
    const { schedule, flexible, customClass, timeZoneId } = this.props;
    return (
      <div data-testing-id='schedule'>
        {flexible ? (
          <p className='flexible'>
            <FormattedMessage
              id='elements_forms.schedule.flexible'
              defaultMessage='My dates are flexible'
            />
          </p>
        ) : (
          ''
        )}
        {schedule && 0 < schedule.length ? (
          displayDateTime.map((time, i) => (
            <div
              className={classNames(
                'date-time-wrapper',
                { 'margin-sm-top': i > 0 },
                customClass
              )}
              key={`date-time-wrapper-${i}`}
              data-testing-id='schedule-datetime'
            >
              <div data-testing-id={`schedule-date-${i}`}>
                {time.start && time.start.date && (
                  <FormattedDate
                    value={time.startDateTime}
                    year='numeric'
                    month='short'
                    day='numeric'
                    weekday='short'
                    timeZone={timeZoneId}
                  />
                )}
              </div>
              <div data-testing-id={`schedule-time-${i}`}>
                {this.checkForDateTime(time)}
              </div>
            </div>
          ))
        ) : flexible ? (
          ''
        ) : (
          <FormattedMessage
            id='web_2.schedule.not_specified'
            defaultMessage='Not specified'
          />
        )}
      </div>
    );
  }
}

getDisplayDateTime.propTypes = {
  schedule: PropTypes.object,
  flexible: PropTypes.bool
};

Schedule.propTypes = {
  schedule:  PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  flexible: PropTypes.bool,
  customClass: PropTypes.string,
  timeZoneId: PropTypes.string,
  intl: intlShape
};

exports.Schedule = injectIntl(Schedule);
